export const zoom = 6;
export const center = [-116.678, 46.097];

export const MAX_FEATURE_SIZE = 500;

export const isValidFeatureSize = count =>
  0 < count && count <= MAX_FEATURE_SIZE;

export const isInvalidFeatureSize = count =>
  count === 0 || count > MAX_FEATURE_SIZE;

export const addWidget = ({ view, component, position }) => view.ui.add(component, position);